import { DashboardScreenshot } from "./DashboardScreenshot";
import DashboardPage from "../pages/DashboardPage";

export function Hero() {
  const scrollToWaitlist = () => {
    document
      .getElementById("waitlist")
      ?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="hero is-fullheight hero-gradient py-6">
      <div className="hero-body">
        <div className="container has-text-centered is-max-desktop">
          <div className="mb-6">
            <span className="tag is-medium is-rounded has-background-info-light px-4 py-2" style={{ height: "auto" }}>
              <span className="mr-2 pulse-ring has-background-primary" style={{ width: "0.5rem", height: "0.5rem", borderRadius: "50%" }} />
              Now in early access
            </span>
          </div>
          <div className="">
            <h1 className="title has-text-text mb-2" style={{ fontSize: "4.5rem" }}>ZK Ops as a Service</h1>
            <h2 className="subtitle is-size-5 has-text-text-60">
              Build, benchmark, and deploy ZK circuits with confidence. The complete platform for zero-knowledge development teams
            </h2>
          </div>
          <div className="my-6">
            <button className="button is-link has-text-white is-medium px-6 py-4" onClick={scrollToWaitlist}>
              <span className="">Join the Waitlist</span>
              <span className="icon">
                <i className="fas fa-arrow-right ml-4"></i>
              </span>
            </button>
          </div>

          {/* <div className="mt-6" > */}
          {/* <div className="mockup-window" style={{maxHeight: "600px"}}> */}
          {/* Window Header */}
          {/* <div className="window-controls">
                <span className="window-dot dot-red" />
                <span className="window-dot dot-yellow" />
                <span className="window-dot dot-green" />
                <span className="text-xs text-gray-500 ml-4">
                  nargklab.com/dashboard
                </span>
              </div> */}

          {/* Dashboard Screenshot */}
          {/* <DashboardScreens   hot /> */}
          {/* <DashboardPage /> */}
          {/* </div> */}
          {/* </div> */}
        </div>
      </div>
    </section>
  );
}